import slugify from 'slugify';

export const getName = (fileName: string) => fileName.replace(/\.[^/.]+$/, '');
export const getSanitizedName = (fileName: string) => slugify(getName(fileName));
export const getExtension = (fileName: string) => fileName?.split('.').pop();

/**
 * @param {string[]} extensions
 */
export const formatAllowedExtensions = (extensions: string[]) =>
  (extensions?.length > 0 ? `(${extensions.map((extension: string) => `.${extension.replace(/^\./, '')}`).join(', ')})` : '');
